import { Component } from '@angular/core';
import { AnimationOptions } from 'ngx-lottie';

@Component({
    selector: 'gs-not-found',
    templateUrl: 'not-found.component.html',
    standalone: false
})

export class NotFoundComponent {
  animationOptionsLight: AnimationOptions = {
    path: 'assets/json/animation-404-light.json',
    loop: true,
    autoplay: true
  };

  animationOptionsDark: AnimationOptions = {
    path: 'assets/json/animation-404-dark.json',
    loop: true,
    autoplay: true
  };

  constructor() { }
}
